module.exports = "<h2 id=\"component-description\">Component Description</h2>\n<p>A Nessie Module is a container for other components with an optional title and an optional collapse toggle. A Nessie Module should wrap other components.</p>\n<h2 id=\"example-usage\">Example Usage</h2>\n<pre><code>&lt;Module title=&quot;This is a Nessie Module&quot;&gt;\n    &lt;div&gt;Some other components go here....&lt;/div&gt;\n&lt;/Module&gt;\n</code></pre>";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader!./node_modules/markdown-loader!./src/Module/README.md
// module id = 363
// module chunks = 0